//////////////////////////////////////////////////////////////////
//
//  汎用モーダル
//
//////////////////////////////////////////////////////////////////

document.addEventListener('DOMContentLoaded', () => {
  let scrollpos = 0;

  // モーダルを開く処理
  document.querySelectorAll('.open_modal').forEach(btn => {
    btn.addEventListener('click', () => {
      const targetId = btn.dataset.target;
      const modal = document.getElementById(targetId);
      if (!modal) return;

      // 背景固定とスクロール位置保持
      scrollpos = window.scrollY;
      Object.assign(document.body.style, {
        position: 'fixed',
        width: '100%',
        top: `-${scrollpos}px`
      });

      // オーバーレイ生成・表示
      let overlay = document.querySelector('.modal_overlay');
      if (!overlay) {
        overlay = document.createElement('div');
        overlay.className = 'modal_overlay';
        document.body.appendChild(overlay);
      }
      overlay.style.display = 'block';
      modal.classList.add('open_modal');

      // 閉じる処理（イベント委譲でまとめて処理）
      const closeModal = () => {
        modal.classList.remove('open_modal');
        overlay.style.display = 'none';
        document.body.removeAttribute('style');
        window.scrollTo(0, scrollpos);
      };

      overlay.onclick = closeModal;
      modal.querySelectorAll('.close_modal, .close_done').forEach(el => el.onclick = closeModal);
    });
  });
});

//////////////////////////////////////////////////////////////////
//
//  スライドメニュー - for smartphone
//
//////////////////////////////////////////////////////////////////

/*$(function(){
  var wrp      = '.lang_jp, lang_en',
        btnOpen  = '.btn_pagenavi',
        btnClose = '.slide_menu_close',
        sld      = '.slide_menu',
        ovrly    = '.slide_menu_overlay',
        current_scrollY;

  $(btnOpen).on('click',function(e){
    if($(sld).css('display') == 'none'){
      current_scrollY = $( window ).scrollTop();
      $(wrp).css({
        position: 'absolute',
        width: '100%',
        top: -1 * current_scrollY
      });
      $(sld).slideDown('fast','swing');
      $(ovrly).css('display','block');
    }
  });

  $(btnClose).on('click',function(){
    if($(sld).css('display') == 'block'){
      $(wrp).attr({style:''});
      $('html, body').prop({scrollTop: current_scrollY});
      $(sld).slideUp('fast','swing');
      $(ovrly).fadeOut();
    }
  });

  $(document).on('click',function(e) {
    if($(sld).css('display') == 'block'){
      if ((!$(e.target).closest(sld).length)&&(!$(e.target).closest(btnOpen).length)) {
        $(wrp).attr({style:''});
        $('html, body').prop({scrollTop: current_scrollY});
        $(sld).slideUp('fast','swing');
        $(ovrly).fadeOut();
      }
    }
  });

});`*/

/*$(function(){
  var state = false;
  var scrollpos;
 
  $('.footer-menu-pagenavi').on('click', function(){
    if(state == false) {
      scrollpos = $(window).scrollTop();
      $('body').addClass('slide_menu_fixed').css({'top': -scrollpos});
      $('.slide_menu').slideDown('fast','swing');
      $('.slide_menu_overlay').css('display','block');
      state = true;
    }
  });
  $('.slide_menu_close').on('click', function(){
    if(state == true) {
      $('body').removeClass('slide_menu_fixed').css({'bottom': 0});
      window.scrollTo( 0 , scrollpos );
      $('.slide_menu').slideUp('fast','swing');
      $('.slide_menu_overlay').fadeOut();
      state = false;
    }
  });
 
 
});*/

//
// トップコンテンツモーダル
//////////////////////////////////////////////////////////////////

/*$(function(){
  $('.open_modal_top').click(function(){

    scrollpos = $(window).scrollTop();
    $('body').css({ 'top': -scrollpos });
    $('.slider-pro').append('<div class="modal_top_overlay"></div>');
    $('.modal_top_overlay').fadeIn('fast');
    $('#top_contents').sliderPro({
      autoplay: false//自動再生
    });

    var modal = '#' + $(this).attr('data-target');

    modalResize();

    $(modal).addClass('open_modal_top_contents');

    $('.modal_top_overlay, .close_modal').off().click(function(){
      $(modal).removeClass('open_modal_top_contents');
      $('.modal_top_overlay').fadeOut('fast',function(){
        window.scrollTo(0, scrollpos);
        $('.modal_top_overlay').remove();
      });
      $('#top_contents').sliderPro({
        autoplay: true//自動再生
      });
    });

    $(window).on('resize', function(){
      modalResize();
    });

    function modalResize(){
      var w = $(window).width();
      var h = $(window).height();

      var x = (w - $(modal).outerWidth(true)) / 2;
      var y = (h - $(modal).outerHeight(true)) / 2;

      $(modal).load;
    }
  });
});*/

//
// サイドメニュー
//////////////////////////////////////////////////////////////////

/*$(function(){
  $('.trigger_pagenavi').click(function(){

    //scrollpos = $(window).scrollTop();
    //$('body').css({ 'top': -scrollpos });

    // ページcss背景設定のz-indexの解除
    $('.l_bgimg').addClass('cancel_zindex'); 

    $('body').append('<div class="modal_overlay"></div>');
    $('.modal_overlay').fadeIn('fast');

    var modal = '.' + $(this).attr('data-target');

    modalResize();

    $(modal).addClass('pagenavi');
    $(modal).slideDown('pagenavi');

    $('.btn_pagenavi_cancel').addClass('btn_pagenavi_cancel_on');
    $('.btn_pagenavi_compare').addClass('btn_pagenavi_compare_on');
    $('.btn_pagenavi_block').hide();

    $('.modal_overlay').click(function(){
      $(modal).removeClass('pagenavi');
      $('.modal_overlay').fadeOut('fast',function(){
        //window.scrollTo(0, scrollpos);
        $('.modal_overlay').remove();
      });
      $('.btn_pagenavi_cancel').removeClass('btn_pagenavi_cancel_on');
      $('.btn_pagenavi_block').show();
      // ページcss背景設定のz-indexの再設定
      $('.l_bgimg').removeClass('cancel_zindex');
    });

    // リサイズしたら表示位置を再取得
    $(window).on('resize', function(){
      modalResize();
    });

    // モーダルコンテンツの表示位置を設定する関数
    function modalResize(){
      // ウィンドウの横幅、高さを取得
      var w = $(window).width();
      var h = $(window).height();

      // モーダルコンテンツの表示位置を取得
      var x = (w - $(modal).outerWidth(true)) / 2;
      var y = (h - $(modal).outerHeight(true)) / 2;

      // モーダルコンテンツの表示位置を設定
      //$(modal).css({'left': x + 'px','top': y + 'px'});
      $(modal).load;
    }
  });

  $('.btn_pagenavi_cancel').click(function () {
    $('.btn_pagenavi_cancel').removeClass('btn_pagenavi_cancel_on');
    $('.btn_pagenavi_block').show();
    $('.target_pagenavi').removeClass('pagenavi');
    $('.modal_overlay').fadeOut('fast',function(){
      //window.scrollTo(0, scrollpos);
      $('.modal_overlay').remove();
    });

    // ページcss背景設定のz-indexの再設定
    $('.l_bgimg').removeClass('cancel_zindex');
  });
});*/